import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import ContactUsComponent from '../../components/ContactUsComponent'
import { Helmet } from 'react-helmet-async'


const bodyContainer = [
  {
    name: "Rental Software",
    link: "/case-studies/rental-software",
    imgPath: "../images/rd-rental.png"
  },
  {
    name: "Church Directory",
    link: "/case-studies/church-directory",
    imgPath: "../images/church-directory.png"
  },
  {
    name: "POS System",
    link: "/case-studies/pos-system",
    imgPath: "../images/pos-system.png"
  },
  {
    name: "Event Management System",
    link: "/case-studies/event-management-system",
    imgPath: "../images/event-management-system.png"
  },
  {
    name: "Project Management System",
    link: "/case-studies/project-management-system",
    imgPath: "../images/jjkit-project-management.png"
  },
  {
    name: "CRM",
    link: "/case-studies/crm",
    imgPath: "../images/jvcrm.png"
  },
  {
    name: "Time Sheet",
    link: "/case-studies/time-sheet",
    imgPath: "../images/jjtimesheet-employees-management.png"
  }
]

const CaseStudies = () => {
  return (
    <>
      <Helmet>
        <title>Data Repo | Software Development Case Studies & Success Stories</title>
        <meta
          name="description"
          content="Explore real-world software development case studies by Data Repo, including rental management systems, church directory platforms, POS solutions, and event management software."
        />
      </Helmet>

      <section
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&q=80&w=1470&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D")',
          backgroundSize: "100% 80vh"
        }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border md:h-[80vh] pt-[65px]">
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase">Software Development Case Studies</h1>
        <div className="row--image-style bg-transparent w-full absolute bottom-0 left-0 right-0">
          <svg className="waves w-full h-44" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 300" preserveAspectRatio="none">
            <path fill="rgb(226 232 240)" d="M 1000 280 l 2 -253 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -235 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"></path>
            <path fill="rgb(100 116 139)" d="M 1000 261 l 2 -222 c -157 -43 -312 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -153.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 16.61 v 22.39 z"></path>
            <path fill="white" d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"></path>
          </svg>
        </div>
      </section>

      <h2 className="text-3xl font-bold text-center mt-10 mb-4">
        Real-World Software Solutions Delivered
      </h2>

      <section className="px-6 md:px-16 py-4 text-center max-w-5xl mx-auto">
        <p className="text-lg text-gray-700">
          Discover how Data Repo helps businesses transform ideas into intelligent software
          solutions. Our case studies highlight real-world projects across rental management,
          event platforms, POS systems, and community applications.
        </p>
      </section>

      <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24 flex flex-wrap gap-6">
        {bodyContainer.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundImage: `url('${item.imgPath}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="body--view w-full sm:w-[48%] md:w-[31%] lg:w-[23%] h-80 py-8 px-6 rounded-md bg-no-repeat flex items-end justify-between
                 bg-black/50 bg-blend-darken
                 hover:bg-black/60 transition duration-300"
          >
            <h4 className="text-white text-2xl md:text-sm lg:text-lg font-semibold">
              {item.name}
            </h4>

            <Link
              to={item.link}
              aria-label={`Read case study about ${item.name}`}
              title={`${item.name} software case study by Data Repo`}
              className="w-8 h-8 p-2 rounded-full bg-transparent text-white flex items-center justify-center border-2 border-white hover:text-slate-300 hover:border-slate-300 transition"
            >
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        ))}
      </section>

      <ContactUsComponent />
    </>
  )
}

export default CaseStudies